import { getCurrentSiteId } from '@jwplayer/companion/sites';
import type { HrefProps } from '@jwplayer/wui-components/dist/types/modules/href';
import type { RedirectProps } from 'react-router-dom';

import { browserHistory } from '/app/history';

import type { LocationDescriptor } from './types';
import { getLocationDescriptorObject } from './util';

/**
 * Redirect to a specific Dashboard route.
 */
export function redirect(
  props: Omit<RedirectProps, 'to'> & {
    to: LocationDescriptor;
    openInNewTab?: boolean;
  },
) {
  const to = getLocationDescriptorObject(props.to, {
    routeParams: {
      siteId: getCurrentSiteId(),
    },
  });

  if (!to.pathname) {
    return;
  }

  const fullPath = to.pathname + to.search;
  if (props.openInNewTab) {
    window.open(fullPath, '_blank', 'noreferrer');
  } else if (to.external) {
    window.location.replace(fullPath);
  } else {
    browserHistory.push(fullPath);
  }
}

export function getLink(to: LocationDescriptor) {
  const toObj = getLocationDescriptorObject(to, {
    routeParams: { siteId: getCurrentSiteId() },
  });

  if (!toObj.pathname) {
    return;
  }

  return toObj.pathname + toObj.search;
}

export function getAnchorProps(
  to: LocationDescriptor | undefined | null,
  opts?: { target?: HrefProps['target'] },
): HrefProps & { disabled?: boolean } {
  if (!to) {
    return {};
  }

  const link = getLink(to);

  const disabled = !link;

  return {
    href: link,
    target: opts?.target,
    disabled,
    onClick: (e) => {
      // Prevent default 'a' behavior and redirect manually
      e.preventDefault();

      if (disabled) {
        e.stopImmediatePropagation();
        return;
      }

      redirect({ to, openInNewTab: e.metaKey });
    },
    rel: 'noopener noreferrer',
  };
}
